// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"8ba38efff322e843bb1c","3":"278177484bdb89b35139","4":"02dc6a470f2ee12e64db","5":"8c7f4066d70a218036fc"}[chunkId] + "";
};